export default "__VITE_ASSET__a968c052__"